import PropTypes from 'prop-types';

import isFunction from './isFunction';
import isTruthy from './isTruthy';

const defaultProps = {
  on: false,
  children: null,
};

const propTypes = {
  on: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
  ]),
  children: PropTypes.node,
};

const ConditionalRendering = ({
  on,
  children,
}) => {
  let condition = on;
  if (isFunction(condition)) {
    condition = condition();
  }
  if (!isTruthy(condition)) {
    return null;
  }

  return children;
};

ConditionalRendering.defaultProps = defaultProps;
ConditionalRendering.propTypes = propTypes;

export default ConditionalRendering;
